export const fans = 
    [
        { text: '全部', value: '' },
        { text: '1000万以上', value: '10000000,100000000' },
        { text: '500万-1000万', value: '5000000,10000000' },
        { text: '200万-500万', value: '2000000,5000000' },
        { text: '100万-200万', value: '1000000,2000000' },
        { text: '50万-100万', value: '500000,1000000' },
        { text: '20万-50万', value: '200000,500000' },
        { text: '10万-20万', value: '100000,200000' },
        { text: '10万以下', value: '0,100000' },
      ]
export const liveType = [
        { text: '全部', value: '' },
        { text: '带货直播', value: 1 },
        { text: '非带货直播', value: 0 },
]